// @noflow
import { barColourModes, responsiveVars } from '../../../constants';

import { convertRGBToHex } from '~/core/utils/colour';
import PropTypes from 'prop-types';
import * as React from 'react';
import { VelocityComponent } from 'velocity-react';

const { YDOMAIN, XINDEX, SINGLE } = barColourModes;
const { BAR_RADIUS_MEDIUM, BAR_RADIUS_SMALL, BAR_AMOUNT_LIMIT } = responsiveVars;

/************************
 *   Helper functions   *
 ************************/

const _getHexColour = colour => (colour.includes('#') ? colour : convertRGBToHex(colour));

const _getBarColour = ({ barColours, barColourMode, index, yValue }) => {
    const colourMap = {
        [YDOMAIN]: barColours[parseInt(yValue, 10)],
        [XINDEX]: barColours[index],
        [SINGLE]: barColours[0]
    };
    return _getHexColour(colourMap[barColourMode] || colourMap[SINGLE]);
};

/*****************
 *   Component   *
 *****************/

const BarComponentPropTypes = {
    actualBarChartLength: PropTypes.number.isRequired,
    animDuration: PropTypes.number.isRequired,
    barChartLength: PropTypes.number.isRequired,
    barColourMode: PropTypes.string.isRequired,
    barColours: PropTypes.array.isRequired,
    compWidth: PropTypes.number.isRequired,
    data: PropTypes.shape({
        height: PropTypes.number,
        labelX: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        width: PropTypes.number.isRequired,
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
    }).isRequired,
    gutter: PropTypes.number.isRequired,
    handleMouseOut: PropTypes.func.isRequired,
    handleMouseOver: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    xDomain: PropTypes.string.isRequired,
    yDomain: PropTypes.string.isRequired,
    yStart: PropTypes.number.isRequired
};

const BarComponent = ({
    actualBarChartLength,
    animDuration,
    barChartLength,
    compWidth,
    data,
    barColours,
    barColourMode,
    gutter,
    handleMouseOver,
    handleMouseOut,
    index,
    xDomain,
    yDomain,
    yStart
}) => {
    const { height, labelX, width, x, y } = data;
    const barRadius = barChartLength > BAR_AMOUNT_LIMIT ? BAR_RADIUS_SMALL : BAR_RADIUS_MEDIUM;
    const barColour = _getBarColour({
        barColours,
        barColourMode,
        index: index,
        yValue: data[yDomain]
    });
    const delayTotal = animDuration * 0.5;
    const delayUnit = delayTotal / actualBarChartLength;
    const duration = animDuration - delayTotal;
    const delay = index * delayUnit;
    const heightStart = 0;
    const startColour = _getHexColour(barColours[0]);
    const hiddenX = x;
    const hiddenWidth = width + gutter;
    const mouseOver = () =>
        handleMouseOver({
            backgroundColour: barColour,
            x: x + width / 2,
            xLabel: labelX || data[xDomain],
            y: y,
            yLabel: data[yDomain]
        });
    return (
        <g>
            <VelocityComponent
                animation={{
                    height: [height, heightStart],
                    y: [y, yStart],
                    fill: [barColour, startColour]
                }}
                delay={delay}
                duration={duration}
                easing="ease-in-out"
                runOnMount
            >
                <rect rx={barRadius} ry={barRadius} width={width} x={x} />
            </VelocityComponent>
            <rect
                fill="transparent"
                height={height}
                onClick={mouseOver}
                onMouseEnter={mouseOver}
                onMouseLeave={handleMouseOut}
                width={hiddenWidth}
                x={hiddenX}
                y={y}
            />
        </g>
    );
};

BarComponent.propTypes = BarComponentPropTypes;

export default BarComponent;



// WEBPACK FOOTER //
// ./src/components/widgets/bar-graph/graph/bars/bar/index.js